<template>
  <div v-if="dataPermission.includes('CNPS_DEVICE_ORDER_IMPORT_CREATE')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>{{ isUpdate ? `Cập nhật phiếu nhập kho ${billNumber}` : 'Thêm phiếu nhập kho' }}</h1>
      <div class="float-right btn-group">
        <button type="button" class="font-medium btn btn-outline-secondary" @click="requestItem()">
          <i class="bx bx-save"></i> {{ isUpdate ? 'Lưu' : 'Tạo' }}
        </button>
        <button
          type="button"
          class="font-medium btn btn-outline-secondary"
          @click="checkCloseAdd()"
        >
          <i class="bx bx-exit"></i> Hủy bỏ
        </button>
      </div>
    </div>

    <div class="p-10 card pt-15 b-t-1-869fb229">
      <ValidationObserver ref="inventoryRef" class="px-20 mt-2 card-body row">
        <form class="col-md-6">
          <ValidationProvider rules="required" vid="dateImport" name="Ngày nhập">
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label">
                Ngày nhập <span style="color: red">*</span>
              </label>
              <div class="col-sm-7">
                <datepicker
                  format="dd/MM/yyyy"
                  :language="vi"
                  v-model="dataAdd.dateImport"
                  placeholder="Ngày nhập"
                ></datepicker>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required" vid="inventoryId" name="Tên kho nhập">
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label">
                Tên kho nhập <span style="color: red">*</span>
              </label>
              <div class="col-sm-7">
                <Select2
                  placeholder="Tên kho nhập"
                  v-model="dataAdd.inventoryId"
                  :options="warehouseData"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" vid="cityCode" name="Lý do nhập">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label">
                Lý do nhập <span style="color: red">*</span>
              </label>
              <div class="col-sm-7">
                <select
                  v-model="dataAdd.reasonImport"
                  class="form-control"
                  placeholder="Lý do nhập"
                >
                  <option
                    v-for="re in reasonImportData.filter(
                      s =>
                        (dataUser.typeSale !== 'SALE_DIRECTOR' &&
                          !['ENTER_REFUND', 'ENTER_LIQUIDATE'].includes(s.id)) ||
                        dataUser.typeSale === 'SALE_DIRECTOR'
                    )"
                    :key="re.id"
                    :value="re.id"
                  >
                    {{ re.text }}
                  </option>
                </select>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider
            :rules="dataAdd.reasonImport === 'NEW_PURCHASE' ? 'required' : ''"
            vid="supplierId"
            name="Nhà cung cấp"
          >
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label">
                Nhà cung cấp
                <span v-if="dataAdd.reasonImport === 'NEW_PURCHASE'" style="color: red">*</span>
              </label>
              <div class="col-sm-7">
                <Select2
                  placeholder="nhà cung cấp"
                  v-model="dataAdd.supplierId"
                  :options="supplierData"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider vid="supplierId" name="Loại thiết bị" rules="required">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label">
                Loại thiết bị <span style="color: red">*</span>
              </label>
              <div class="col-sm-7">
                <Select2
                  :disabled="isUpdate"
                  @change="checkTypeKind(typeDevice)"
                  placeholder="Loại thiết bị"
                  v-model="typeDevice"
                  :options="typeDeviceOption"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="maxReceipt_2" vid="description" name="Ghi chú">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label">Ghi chú</label>
              <div class="col-sm-7">
                <input
                  v-model.trim="dataAdd.description"
                  type="text"
                  class="form-control"
                  placeholder="Ghi chú"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider
            name="Loại nhập kho"
            rules="required"
            v-slot="{ errors, valid }"
            v-if="typeDevice === 'SERIAL'"
          >
            <div class="form-group row">
              <label for class="col-sm-3 col-form-label">
                Loại nhập kho
                <span style="color: red">*</span>
              </label>
              <div class="col-sm-7">
                <b-form-radio-group
                  :state="errors[0] ? false : valid ? true : null"
                  v-model="dataAdd.typeImport"
                  @change="checkImportBy"
                  class="d-flex justify-content-between"
                >
                  <div
                    class="form-check form-check-inline w-45"
                    v-for="op in typeImportData"
                    :key="op.id"
                  >
                    <b-form-radio :id="`importBy${op.id}`" :value="op.id"></b-form-radio>
                    <label class="form-check-label" :for="`importBy${op.id}`">
                      {{ op.text }}
                    </label>
                  </div>
                </b-form-radio-group>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
        </form>

        <form class="col-md-6"></form>
      </ValidationObserver>

      <div class="p-10 pt-2 card">
        <div
          class="mb-2 d-flex pos-relative w-100 justify-content-between align-items-baseline flex-wrap"
        >
          <h1 class="mb-1 form-inner-heading">Bảng thông tin thiết bị</h1>
          <div class="float-right btn-group">
            <button
              v-if="dataAdd.typeImport === 'IMPORT_ODD'"
              @click="openAddDevice"
              class="font-medium f12 btn btn-outline-secondary"
            >
              <i class="bx bxs-plus-circle"></i> Thêm
            </button>
            <button
              @click="deleteDeviceMul"
              v-if="selected.length > 0"
              class="font-medium f12 btn btn-outline-secondary"
            >
              <i class="bx bx-minus-circle"></i> Xoá
            </button>
            <button
              @click="downloadFileTemplateExcel"
              v-if="dataAdd.typeImport === 'IMPORT_FILE'"
              class="font-medium f12 btn btn-outline-secondary"
            >
              <i class="bx bx-download"></i> Tải file mẫu
            </button>
            <!-- && dataAdd.reasonImport === 'NEW_PURCHASE' -->
            <button
              v-if="dataAdd.typeImport === 'IMPORT_FILE' && !hasFileImport"
              @click="$refs.uploadFileExcel.click()"
              class="font-medium f12 btn btn-outline-secondary"
            >
              <i class="bx bx-upload"></i> Nhập file
            </button>
            <button
              v-if="dataAdd.typeImport === 'IMPORT_FILE' && hasFileImport"
              @click="$refs.uploadFileExcel.click()"
              class="font-medium f12 btn btn-outline-secondary"
            >
              <i class="bx bx-edit-alt"></i> Chọn lại file
            </button>
            <input
              style="display: none"
              ref="uploadFileExcel"
              @change="uploadFileExcel"
              type="file"
            />
          </div>
        </div>
        <div class="tab-content">
          <div class="table-responsive" style="overflow: auto; max-height: 70vh">
            <table class="table table-hover table-bordered">
              <thead class="thead-light">
                <tr class="text-center">
                  <th>
                    <input type="checkbox" v-model="selectAll" />
                  </th>
                  <th>Tên thiết bị</th>
                  <th v-if="typeDevice === 'SERIAL'">Mã Serial</th>
                  <th v-if="typeDevice === 'NO_SERIAL'">Số lượng</th>
                  <th>Số thùng</th>
                  <th>Ghi chú</th>
                  <th>Thao tác</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="table-row text-center"
                  v-for="(device, index) in dataAdd.orderDevices"
                  :key="`device${index}`"
                >
                  <td>
                    <input type="checkbox" v-model="selected" :value="device" />
                  </td>
                  <td class="text-center">{{ device.categoryName }}</td>
                  <td v-if="typeDevice === 'SERIAL'">{{ device.serial }}</td>
                  <td v-if="typeDevice === 'NO_SERIAL'">{{ device.quantity }}</td>
                  <td>{{ device.numberGear }}</td>
                  <td>{{ device.noteImport }}</td>
                  <td>
                    <b-dropdown class="text-center" variant="outline-light">
                      <button class="dropdown-item" @click="openEditDevice(device, index)">
                        <i class="bx bx-pencil"></i>&nbsp; Sửa
                      </button>
                      <button class="dropdown-item" @click="deleteDevice(index)">
                        <i class="bx bx-minus-circle"></i>&nbsp; Xoá
                      </button>
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModalNoti">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalNoti = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="text-center modal-body">
                  <img :src="srcImage" alt="icon-successs" />
                  <h2 class="py-3 f18">{{ messNoti }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="closeAdd"
                    data-dismiss="modal"
                    v-if="keyCheck === 'accept' || keyCheck === 'back' || keyCheck === 'addLead'"
                  >
                    Đồng ý
                  </button>
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalNoti = false"
                    data-dismiss="modal"
                    v-if="keyCheck === 'cancel' || keyCheck === 'back'"
                  >
                    Bỏ qua
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <b-modal
      id="modal-noti"
      centered
      v-model="modalEditDevice"
      ignore-enforce-focus-selector="input"
    >
      <template #modal-header="{ close }">
        <h5>{{ modalEditDeviceStatus === 'add' ? 'Thêm' : 'Sửa' }} thiết bị</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <ValidationObserver ref="deviceRef" class="px-20 mt-2 card-body" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(requestDevice)">
          <ValidationProvider rules="required" vid="deviceName" name="Tên thiết bị">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label">
                Tên thiết bị <span style="color: red">*</span>
              </label>
              <div class="col-sm-7">
                <Select2
                  class="select-input"
                  placeholder="Tên thiết bị"
                  v-model="device.categoryName"
                  :options="deviceData"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider
            v-if="typeDevice === 'SERIAL'"
            rules="required|minMaxName_2"
            vid="deviceSerial"
            name="Mã serial"
          >
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label">
                Mã serial <span style="color: red">*</span>
              </label>
              <div class="col-sm-7">
                <input
                  v-model.trim="device.serial"
                  type="text"
                  class="form-control"
                  placeholder="Mã serial"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider
            v-if="typeDevice === 'NO_SERIAL'"
            rules="required"
            vid="deviceSerial"
            name="Số lượng"
          >
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label">
                Số lượng <span style="color: red">*</span>
              </label>
              <div class="col-sm-7">
                <input
                  v-model.trim="device.quantity"
                  type="number"
                  class="form-control"
                  placeholder="Số lượng"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required|minMaxName_2" vid="numberGear" name="Số thùng">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label">
                Số thùng <span style="color: red">*</span>
              </label>
              <div class="col-sm-7">
                <input
                  v-model.trim="device.numberGear"
                  type="text"
                  class="form-control"
                  placeholder="Số thùng"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="maxReceipt_2" vid="deviceNote" name="Ghi chú">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label">Ghi chú</label>
              <div class="col-sm-7">
                <input
                  v-model.trim="device.description"
                  type="text"
                  class="form-control"
                  placeholder="Ghi chú"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <button type="submit" v-show="false" />
        </form>
      </ValidationObserver>
      <template #modal-footer="{ cancel }">
        <b-button @click="requestDevice" size="md" variant="primary">
          {{ modalEditDeviceStatus === 'add' ? 'Thêm' : 'Cập nhật' }}
        </b-button>
        <b-button size="md" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { v4 as uuidv4 } from 'uuid'
  import { mapGetters } from 'vuex'
  import { DeviceService } from '@/services/device.service'
  import { vi } from 'vuejs-datepicker/dist/locale'
  import cloneDeep from 'lodash/cloneDeep'
  import differenceBy from 'lodash/differenceBy'
  import Config from '../../../thirdParty/config'

  export default {
    data() {
      return {
        billNumber: '',
        isUpdate: false,
        dataAdd: {
          dateImport: new Date().getTime(),
          reasonImport: 'NEW_PURCHASE',
          typeImport: 'IMPORT_FILE',
          orderDevices: [],
        },
        dataUser: JSON.parse(localStorage.getItem('userData')),
        loading: false,
        showModalNoti: false,
        messNoti: '',
        srcImage: '',
        keyCheck: 'cancel',
        vi: vi,
        selected: [],
        typeImportData: Config.typeImportWarehouse,
        reasonImportData: Config.reasonImportWarehouse.filter(s =>
          ['NEW_PURCHASE', 'ENTER_REFUND', 'ENTER_LIQUIDATE'].includes(s.id)
        ),
        modalEditDevice: false,
        modalEditDeviceStatus: 'add',
        warehouseData: [],
        supplierData: [],
        deviceData: [],
        device: {},
        deviceIndex: 0,
        hasFileImport: false,
        typeDeviceOption: [
          { id: 'SERIAL', text: 'Có serial' },
          { id: 'NO_SERIAL', text: 'Không có serial' },
        ],
        typeDevice: '',
      }
    },

    created() {
      this.checkHasCoppy()
      this.fetchWarehouse()
      this.fetchSupplier()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      selectAll: {
        get: function () {
          return this.dataAdd.orderDevices
            ? this.selected.length === this.dataAdd.orderDevices.length
            : false
        },
        set: function (value) {
          if (value) {
            this.selected = cloneDeep(this.dataAdd.orderDevices)
          } else this.selected = []
        },
      },
    },

    methods: {
      async checkHasCoppy() {
        if (this.$route.params.coppyFrom || this.$route.params.entryId) {
          if (this.$route.params.entryId) {
            this.isUpdate = true
          }
          this.loading = true
          const res = await DeviceService.detailImportWarehouse(
            this.$route.params.coppyFrom ?? this.$route.params.entryId
          )
          if (res.code === 1000) {
            this.billNumber = res.data.billNumber
            const listCopy = {
              dateImport: res.data.timeImport,
              inventoryId: res.data.inventoryIdImport,
              reasonImport: res.data.reasonImport,
              supplierId: res.data.supplier,
              description: res.data.description,
              typeImport: res.data.typeImport,
              orderDevices: res.data.devices,
              kindImport: res.data.kindImport,
            }
            this.dataAdd = listCopy
            if (res.data.kindImport === 'NORMAL') {
              this.typeDevice = 'NO_SERIAL'
            } else this.typeDevice = 'SERIAL'
          }
          this.loading = false
        }
      },

      async checkCloseAdd() {
        if (this.keyCheck) {
          this.showErr('Bạn có chắc chắn muốn huỷ bỏ thao tác không ?')
          this.keyCheck = 'back'
        }
        this.closeAdd()
      },

      async closeAdd() {
        this.$router.push('/import-warehouse')
      },
      async fetchWarehouse() {
        const response = await DeviceService.getListWarehouseUserActive()
        this.warehouseData = response.data.map(({ id, name }) => {
          return { id, text: name }
        })
      },
      async fetchDeviceByKind(kind, type = true) {
        try {
          this.loading = true
          const params = {
            kind: kind,
          }
          const response = await DeviceService.deviceKindNomal(params)
          this.deviceData = response.data.map(({ name }) => {
            return { id: name, text: name }
          })
          if (type) {
            this.modalEditDevice = true
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      async fetchSupplier() {
        const response = await DeviceService.getListSupllier({
          limit: 1000,
          page: 1,
        })
        this.supplierData = response.data.map(({ id, name }) => {
          return { id, text: name }
        })
      },

      async requestItem() {
        const isSuccess = await this.$refs.inventoryRef.validate()
        if (!isSuccess) {
          this.keyCheck = 'cancel'
          return
        }
        if (this.dataAdd.orderDevices.length === 0) {
          this.showErr('Danh sách thiết bị không được bỏ trống')
          return
        }
        try {
          this.loading = true
          const params = cloneDeep(this.dataAdd)
          params.id = this.$route.params.entryId
          params.dateImport = new Date(params.dateImport).getTime()
          let response = {}
          if (this.isUpdate) {
            params.orderDevices = params.orderDevices.map(s => {
              if (this.typeDevice === 'SERIAL') {
                return s.dateCreate
                  ? {
                      deviceId: s.id,
                      categoryName: s.categoryName,
                      serial: s.serial,
                      numberGear: s.numberGear,
                      description: s.description,
                    }
                  : {
                      categoryName: s.categoryName,
                      serial: s.serial,
                      numberGear: s.numberGear,
                      description: s.description,
                    }
              } else if (this.typeDevice === 'NO_SERIAL') {
                return {
                  categoryName: s.categoryName,
                  numberGear: s.numberGear,
                  description: s.description,
                  kind: 'NORMAL',
                  quantity: Number(s.quantity),
                }
              }
            })
            response = await DeviceService.updateImportWarehouse(params)
          } else {
            params.orderDevices = params.orderDevices.map(s => {
              if (this.typeDevice === 'SERIAL') {
                return {
                  categoryName: s.categoryName,
                  serial: s.serial,
                  numberGear: s.numberGear,
                  description: s.description,
                }
              } else if (this.typeDevice === 'NO_SERIAL') {
                return {
                  categoryName: s.categoryName,
                  numberGear: s.numberGear,
                  description: s.description,
                  kind: 'NORMAL',
                  quantity: Number(s.quantity),
                }
              }
            })
            response = await DeviceService.createImportWarehouse(params)
          }
          if (response.code === 1000) {
            this.keyCheck = 'accept'
            this.showSuccess(
              this.isUpdate
                ? 'Cập nhật phiếu nhập kho thành công !'
                : 'Thêm phiếu nhập kho thành công !'
            )
          } else if (response.code === 1025 || response.code === 1039 || response.code === 1042) {
            this.keyCheck = 'addLead'
            this.showErr(response.message)
          } else {
            this.keyCheck = 'cancel'
            this.showErr(response.message)
          }
        } catch (error) {
          if (error.message) this.showErr(error.message)
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      showErr(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-unsuccess2.svg')
      },
      showSuccess(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-success2.svg')
      },

      checkToActionModal(keyCheck) {
        if (keyCheck === 'accept' || keyCheck === 'back') {
          this.showModalNoti = false
          this.closeAdd()
        }
        if (keyCheck === 'addLead') {
          this.showModalNoti = false
          this.requestItem()
        }
      },
      checkImportBy() {
        if (this.dataAdd.orderDevices.length === 0) return
        const h = this.$createElement
        const messageVNode = h('p', {
          domProps: {
            innerHTML:
              'Mọi dữ liệu trên bảng thông tin thiết bị sẽ bị xoá hết khi bạn thay đổi lựa chọn!',
          },
        })
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Lưu ý',
            okTitle: 'Xác nhận',
            cancelTitle: 'Huỷ',
            centered: true,
          })
          .then(value => {
            if (!value) {
              this.dataAdd.typeImport =
                this.dataAdd.typeImport === 'IMPORT_FILE' ? 'IMPORT_ODD' : 'IMPORT_FILE'
            } else this.dataAdd.orderDevices = []
          })
      },
      openEditDevice(device, index) {
        if (this.dataAdd.kindImport === 'NORMAL') {
          this.fetchDeviceByKind('NORMAL', false)
        } else this.fetchDeviceByKind('SERIAL', false)
        this.device = cloneDeep(device)
        this.deviceIndex = index
        this.$nextTick(s => {
          this.modalEditDeviceStatus = 'edit'
          this.modalEditDevice = true
        })
      },
      openAddDevice() {
        this.device = {}
        this.modalEditDeviceStatus = 'add'
        if (this.dataAdd.kindImport === 'NORMAL') {
          this.fetchDeviceByKind('NORMAL')
        } else this.fetchDeviceByKind('SERIAL')
      },
      deleteDevice(index) {
        const h = this.$createElement
        const messageVNode = h('p', {
          domProps: {
            innerHTML: 'Bạn chắc chắn xoá thiết bị trên!',
          },
        })
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Xoá thiết bị',
            okTitle: 'Xoá',
            cancelTitle: 'Huỷ',
            centered: true,
          })
          .then(value => {
            if (value) {
              this.dataAdd.orderDevices.splice(index, 1)
            }
          })
      },
      deleteDeviceMul() {
        const h = this.$createElement
        const messageVNode = h('p', {
          domProps: {
            innerHTML: 'Bạn chắc chắn xoá những thiết bị đã được chọn trên!',
          },
        })
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Xoá thiết bị',
            okTitle: 'Xoá',
            cancelTitle: 'Huỷ',
            centered: true,
          })
          .then(value => {
            if (value) {
              this.dataAdd.orderDevices = differenceBy(
                this.dataAdd.orderDevices,
                this.selected,
                'id'
              )
              this.selected = []
            }
          })
      },
      async requestDevice() {
        if (await this.$refs.deviceRef.validate()) {
          if (this.modalEditDeviceStatus === 'add') {
            this.dataAdd.orderDevices.push({ ...this.device, id: uuidv4() })
          } else {
            this.dataAdd.orderDevices[this.deviceIndex] = this.device
          }
          this.modalEditDevice = false
        }
      },
      async downloadFileTemplateExcel() {
        try {
          this.loading = true
          await DeviceService.downloadFileTemplate()
        } finally {
          this.loading = false
        }
      },
      async dowloadFileError(reqs) {
        try {
          this.loading = true
          await DeviceService.exportDeviceExcelImportWarehouse(reqs)
        } finally {
          this.loading = false
        }
      },
      checkIfHasFileImport() {
        if (this.dataAdd.orderDevices.length === 0 || !this.hasFileImport) {
          return true
        }
        const h = this.$createElement
        const messageVNode = h('p', {
          domProps: {
            innerHTML:
              'Mọi dữ liệu trên bảng thông tin thiết bị sẽ bị thay thế bằng file dữ liệu mới!',
          },
        })
        return this.$bvModal.msgBoxConfirm([messageVNode], {
          title: 'Lưu ý',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
      },
      async uploadFileExcel(file) {
        if (file.target.files.length === 0) return
        if (!(await this.checkIfHasFileImport())) return
        const allowedExtensions = /(\.xls|\.xlsx|\.csv|\.ods)$/i
        const checkFomat = allowedExtensions.exec(file.target.files[0].name)
        if (!checkFomat) {
          this.showErr('Định dạng không hợp lệ !')
          this.$refs.uploadFileExcel.value = null
          return
        }
        this.hasFileImport = true
        const formdata = new FormData()
        formdata.append('file', file.target.files[0])
        try {
          this.loading = true
          const res = await DeviceService.importDeviceExcelImportWarehouse(formdata)
          if (res.code === 1000) {
            this.dataAdd.orderDevices = res.data.correctList.map(s => {
              s.id = uuidv4()
              return s
            })
            this.showMsgOk(res.data)
          } else if (res.code === 1020 || res.code === 1007) {
            this.showErr(
              'Thông tin trong file không đúng quy định hoặc dung lượng file quá lớn (tối đa 25MB)'
            )
          } else if (res.code === 1021 || res.code === 1040) {
            this.showErr(res.res[0].message)
          } else {
            this.showErr(res.message)
          }
        } catch (e) {
          this.showErr(
            'Thông tin trong file không đúng quy định hoặc dung lượng file quá lớn (tối đa 25MB)'
          )
        } finally {
          this.$refs.uploadFileExcel.value = null
          this.loading = false
        }
      },
      showMsgOk(data) {
        const h = this.$createElement
        // Using HTML string
        const titleVNode = h('div', {
          domProps: { innerHTML: 'Import file thành công' },
        })
        // More complex structure
        const messageVNode = h('div', { class: ['text-center'] }, [
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thành công ',
            h('b', data.correctList.length),
            ' bản ghi',
          ]),
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thất bại ',
            h('b', data.errorList.length),
            ' bản ghi',
          ]),
          data.errorList.length > 0 &&
            h(
              'button',
              {
                class: 'f12 font-medium btn btn-outline-danger',
                on: {
                  click: () => this.dowloadFileError(data.errorList),
                },
              },
              'Tải bản ghi thất bại'
            ),
        ])
        this.$bvModal.msgBoxOk([messageVNode], {
          title: [titleVNode],
          centered: true,
        })
      },
      checkTypeKind(type) {
        if (type === 'NO_SERIAL') {
          this.dataAdd.typeImport = 'IMPORT_ODD'
          this.dataAdd.kindImport = 'NORMAL'
        } else {
          if (this.dataAdd.kindImport === 'NORMAL') delete this.dataAdd.kindImport
        }
        if (this.dataAdd.orderDevices.length > 0) {
          this.dataAdd.orderDevices.length = []
        }
      },
    },
  }
</script>

<style scoped>
  .placeholder {
    background: #f0f0f0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 18px;
    font-family: Helvetica;
  }

  .placeholder:hover {
    background: #e0e0e0;
  }
  .form-control-label {
    display: flex !important;
    align-items: center !important;
  }
</style>
